module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12vJslQ/tc-custom/9781913682835.jpg?1723836046829",
      "alt": "This image is the cover for the book Death on Dartmoor, The West County Crime Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Death on Dartmoor, The West County Crime Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In Devon, England, two bodies in a bog send a police detective into the middle of a murky mystery . . .")]), _c('br'), _c('br'), _vm._v(" When an amateur archaeologist makes an unusual find, she calls a scholar at a local college. But this discovery—two headless, handless bodies buried in a bog on Dartmoor—doesn’t re-quire a professor but the police. "), _c('br'), _c('br'), _vm._v(" DI Dan Hellier isn’t sure how he can identify the victims when nobody has reported them miss-ing. And the tension mounts when the death of a young man plunges Hellier into the murky world of the Garrett family. Could the peaceful, family-run Animal Rescue Centre really be a cover for murder and other criminal activity?"), _c('br'), _c('br'), _vm._v(" Hellier is about to learn just how far people will go to get what they want. And this investiga-tion will challenge Hellier’s decisions as he races to catch a murderer before it’s too late."), _c('br'), _c('br'), _c('i', [_vm._v("Previously published as ")]), _vm._v("Death and the Good Son"), _c('i', [_vm._v(" by B.A. Steadman.")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bernie Steadman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0